module.exports = __webpack_public_path__ + "img/qualityManagement.33e92837.jpg";